<template>
    <!-- Button to restore fully hidden menu -->
    <button v-if="hidden" class="half-circle-btn" @click="userToggleMenu">
        <font-awesome-icon icon="chevron-right" />
    </button>
    <div :class="['sidebar', { collapsed, hidden }]">
        <!-- Top part (logo and toggle button) -->
        <div class="d-flex mb-2">
            <div v-if="!collapsed" class="p-2" style="width: 4em; padding-left: 3em !important">
                <img src="../assets/routa_light.png" style="height: 1.1em; width: auto; margin-right: 1em; margin-bottom: .4em;" alt="logo" />
            </div>
            <div class="flex-grow-1 p-2 d-flex justify-content-end">
                <button class="toggle-btn" @click="userToggleMenu" :class="{'icon-centered' : collapsed}">
                    <font-awesome-icon :icon="collapsed ? 'bars' : 'angle-double-left'" />
                </button>
            </div>
        </div>

        <!-- Scrollable Menu Part -->
        <div v-if="menuItems && menuItems.length > 0" class="sidebar-menu-container">
            <ul class="menu">
                <li v-for="(item, index) in menuItems" :key="item.viewName" @mouseleave="hideSubmenu(item)">
                    <div v-if="item.group && item.group !== menuItems[index - 1]?.group" class="menu-group-header">
                        <div class="menu-group-divider" />
                        <span v-if="!collapsed" class="menu-group-label">{{ $t(item.group) }}</span>
                    </div>
                    <div @click="toggleItem(item)" :class="['menu-item', { active: isActive(item) }]">
                        <font-awesome-icon :icon="item.icon" class="menu-icon" :class="{'menu-icon-collapsed' : collapsed}" />
                        <span v-if="!collapsed" class="menu-text">{{ item.title }}</span>
                        <font-awesome-icon v-if="item.children" :icon="(openItems.includes(item.viewName) && !collapsed) ? 'chevron-down' : 'chevron-right'" class="submenu-indicator" />
                    </div>
                    <ul v-if="item.children && !collapsed" :class="['submenu', { 'submenu-open': openItems.includes(item.viewName) }]">
                        <li v-for="subItem in item.children" :key="subItem.viewName"  class="submenu-item-content" @click.stop="selectView(subItem.viewName)">
                            <span class="submenu-text">{{ subItem.title }}</span>
                        </li>
                    </ul>
                    <div v-if="item.children && collapsed && openItems.includes(item.viewName)" class="submenu-popup submenu-open" :style="popupStyle(item)">
                        <ul class="submenu-item-popup">
                            <li v-for="subItem in item.children" :key="subItem.viewName" class="submenu-item-content" @click.stop="selectView(subItem.viewName)">
                                <span class="submenu-text">{{ subItem.title }}</span>
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="sidebar-tools-section">
                    <div class="tools-divider" />
                    <div :class="['menu-item', { active: activeTool === 'favorites' }]" @click="$emit('toolChanged', activeTool === 'favorites' ? null : 'favorites')">
                        <font-awesome-icon icon="star" class="menu-icon" :class="{'menu-icon-collapsed' : collapsed}" />
                        <span v-if="!collapsed" class="menu-text">{{ $t('menu.favorites') }}</span>
                    </div>
                    <div v-if="chatEnabled" :class="['menu-item', { active: activeTool === 'chat' }]" @click="$emit('toolChanged', activeTool === 'chat' ? null : 'chat')">
                        <font-awesome-icon icon="robot" class="menu-icon" :class="{'menu-icon-collapsed' : collapsed}" />
                        <span v-if="!collapsed" class="menu-text">{{ $t('ai_chat.title') }}</span>
                    </div>
                    <div :class="['menu-item', { active: activeTool === 'help' }]" @click="$emit('toolChanged', activeTool === 'help' ? null : 'help')">
                        <font-awesome-icon icon="circle-question" class="menu-icon" :class="{'menu-icon-collapsed' : collapsed}" />
                        <span v-if="!collapsed" class="menu-text">{{ $t('about.open_manual') }}</span>
                    </div>
                    <div :class="['menu-item', { active: activeTool === 'about' }]" @click="$emit('toolChanged', activeTool === 'about' ? null : 'about')">
                        <font-awesome-icon icon="circle-info" class="menu-icon" :class="{'menu-icon-collapsed' : collapsed}" />
                        <span v-if="!collapsed" class="menu-text">{{ $t('menu.about') }}</span>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Bottom part functions -->
        <div v-if="menuItems && menuItems.length > 0" class="nopads">
            <div v-if="!collapsed" class="col-12 row nopads bottom-options">
                <div class="col-3 nopads text-center p-1 pt-2">
                    <span ref="logout1" :title="$t('menu.logout')" @click.stop="$emit('logoutClicked')"><font-awesome-icon class="click-icon" icon="arrow-right-from-bracket"  /></span>
                </div>
                <div class="col-6 nopads text-center p-1">
                    <select v-model="locale" class="form-select form-select-sm">
                        <option v-for="option in options" :key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                </div>
                <div class="col-3 nopads text-center p-1 pt-2">
                    <span ref="user1"  :title="$t('menu.user_account')"  @click.stop="selectView('userAccount')"><font-awesome-icon class="click-icon" icon="user"  /></span>
                </div>
            </div>
            <div v-else class="col-12 nopads pb-2">
                <div class="tools-divider" />
                <div class="col-12 d-flex justify-content-center">
                    <span ref="user2" class="pt-2 pb-2" :title="$t('menu.user_account')" @click.stop="selectView('userAccount')"><font-awesome-icon class="click-icon" icon="user"  /></span>
                </div>
                <div class="col-12 d-flex justify-content-center">
                    <span ref="logout2" class="pt-2 pb-2" :title="$t('menu.logout')" @click.stop="$emit('logoutClicked')"><font-awesome-icon class="click-icon" icon="arrow-right-from-bracket"  /></span>
                </div>
                <div class="col-12 px-1 py-1">
                    <select v-model="locale" class="form-select form-select-sm no-caret" style="width: 50px; margin: auto">
                        <option v-for="option in options" :key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, computed, nextTick, onMounted, onBeforeUnmount} from 'vue';
import {Tooltip} from "bootstrap";

export default {
    name: 'SideMenu',
    props: {
        menuItems: {
            type: Array,
            required: true
        },
        chatEnabled: {
            type: Boolean,
            default: false
        },
        activeTool: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            options: [
                { value: 'fi', text: 'FI' },
                { value: 'en', text: 'EN' },
                { value: 'sv', text: 'SV' },
            ],
            locale: 'en'
        }
    },
    watch: {
        locale(val) {
            this.$i18n.locale = val
        }
    },
    setup(props, { emit }) {
        const collapsedByUser = ref(false);
        const collapsed = ref(false);
        const hidden = ref(false);
        const openItems = ref([]);
        const activeView = ref(null);
        const breakPoint = 768; // Example breakpoint, adjust as necessary
        const isSmallScreen = ref(false);

        // Method to check the screen width
        const checkScreenWidth = () => {
            if (window.innerWidth <= breakPoint && collapsed.value === false) {
                isSmallScreen.value = true
                toggleMenu()
            } else if (window.innerWidth > breakPoint && collapsed.value === true) {
                isSmallScreen.value = false
                toggleMenu()
            }
        };

        const userToggleMenu = () => {
            if (hidden.value) {
                // Show menu
                hidden.value = false
                emit('menuChanged', collapsed.value, hidden.value)
                return
            }
            if (collapsed.value && isSmallScreen.value) {
                // Do not toggle in small screen to large, instead hide menu
                hidden.value = true
                emit('menuChanged', collapsed.value, hidden.value)
                return
            }
            hidden.value = false
            openItems.value = []
            collapsed.value = !collapsed.value
            collapsedByUser.value = collapsed.value
            emit('menuChanged', collapsed.value, hidden.value)
        }

        const toggleMenu = () => {
            // If user clicked to collapse menu, do not restore automatically on screen size change
            if (!collapsed.value || !collapsedByUser.value ) {
                openItems.value = []
                collapsed.value = !collapsed.value
                hidden.value = false
                emit('menuChanged', collapsed.value, hidden.value)
            }
        }

        // On mounted, check screen width
        onMounted(() => {
            checkScreenWidth(); // Check screen width when component is mounted
            // Add resize event listener
            window.addEventListener('resize', checkScreenWidth);
        });

        // On before unmount, clean up the event listener
        onBeforeUnmount(() => {
            window.removeEventListener('resize', checkScreenWidth);
        });

        const toggleItem = async (item) => {
            if (item.children) {
                if (openItems.value.includes(item.viewName)) {
                    openItems.value = openItems.value.filter(i => i !== item.viewName);
                } else {
                    openItems.value.push(item.viewName);
                }
                await nextTick();
            } else {
                selectView(item.viewName);
            }
        };

        const selectView = (viewName) => {
            activeView.value = viewName;
            // Close submenu in collapsed view
            if (collapsed.value) {
                openItems.value = []
            }
            emit('itemClick', viewName);
        };

        const hideSubmenu = (item) => {
            if (collapsed.value) {
                openItems.value = openItems.value.filter(i => i !== item.viewName);
            }
        };

        return { collapsed, hidden, openItems, activeView, toggleItem, selectView, hideSubmenu, toggleMenu, userToggleMenu };
    },
    emits: ['itemClick', 'menuChanged', 'logoutClicked', 'toolChanged'],
    mounted() {
        this.locale = this.getLanguage()
        this.$nextTick(() => this.initTooltips())
    },
    methods: {
        setActiveView(viewName) {
            this.activeView = viewName
        },
        isActive(menuItem) {
            if (menuItem.viewName === this.activeView) {
                return true
            }
            return (menuItem.children && menuItem.children.find(child => child.viewName === this.activeView ))
        },
        initTooltips() {
            if (this.$refs.user1) {
                new Tooltip(this.$refs.user1, this.$refs.user1.getAttribute('title'), 'top')
            }
            if (this.$refs.logout1) {
                new Tooltip(this.$refs.logout1, this.$refs.logout1.getAttribute('title'), 'top')
            }
        },

        popupStyle(item) {
            const index = this.menuItems.findIndex(i => i.viewName === item.viewName)
            return {
                top: `${index * 40}px`
            }
        },

        isCollapsed() {
            return this.collapsed
        },

        getLanguage: function () {
            const lang = navigator.language.split('-')[0]
            switch (lang) {
                case 'en':
                    return 'en'
                case 'fi':
                    return 'fi'
            }
            return 'en'
        },
    }
};
</script>

<style scoped>
.sidebar {
    width: 200px;
    background: #343A40;
    color: white;
    transition: width 0.3s ease;
    overflow: visible;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    z-index: 10 !important;
}

.sidebar-menu-container {
    flex-grow: 1; /* Ensures the menu takes the remaining height */
    overflow-y: auto; /* Enables vertical scrolling */
    padding-top: 10px; /* Optional, for spacing */
    margin-bottom: .5em;
}

@media (min-width: 768px) {
    .sidebar-menu-container {
        margin-bottom: 2.8em;
    }
}


.sidebar.collapsed {
    width: 58px !important;
    overflow: visible;
}

.sidebar.hidden {
    margin-left: -70px;
}

.menu {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: auto;
}

.bottom-options {
    /* Ensure bottom is fixed and does not scroll */
    padding: 10px;
    position: sticky;
    bottom: 0;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: .3em .7em;
    cursor: pointer;
    Transition: background 0.3s ease;
    white-space: nowrap;
    position: relative;
    color: #ffffff;
    border-left: 5px solid #343A40;
    font-size: .95em;
}

.menu-item:hover {
    background-color: #525252;
}

.menu-item.active {
    color: #a3ea18 !important;
    border-left: 5px solid #a3ea18;
}
.menu-icon {
    margin-right: 5px;
    width: 1em;
}

.menu-icon-collapsed {
    margin-top: 4px;
    margin-bottom: 4px;
}


.menu-item.collapsed {
    padding-right: 10px;
}

.menu-text {
    flex-grow: 1;
    text-align: left;
    padding-left: .2em;
    padding-right: .1em;
}

.submenu {
    list-style: none;
    margin: 0;
    max-height: 0;
    overflow: hidden;
    Transition: height 0.3s ease-out, opacity 0.3s ease;
    opacity: 0;
    color: #FFFFFF;
    display: block;
    padding: .2em;
    font-size: .9em;
    text-align: start;
}


.submenu-item-popup {
    padding-left: 0;
    padding-right: 0;
    padding-top: .25em;
    padding-bottom: .25em;
    list-style: none;
    color: #FFFFFF;
}

.submenu-item-popup {
    margin-left: -1.6em !important;
}

.submenu-item-content {
    margin: 0;
    padding: .3em 3em;
    cursor: pointer;
}

.submenu-item-content:hover {
    color: #a3ea18 !important;
}

.submenu-open {
    max-height: 500px;
    opacity: 1;
}
.submenu-text{
    cursor: pointer;
}
.submenu-indicator {
    font-size: 12px;
    margin-left: auto;
}

.submenu-popup {
    list-style: none;
    position: absolute;
    left: 100%;
    color: #FFFFFF;
    background: #343A40;
    margin: 0;
    margin-left: .1em;
    padding: .5em 0;
    padding-left: 1em;
    min-width: 200px;
    max-width: 400px;
    box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5);
    border-top-right-radius: .3em;
    border-bottom-right-radius: .3em;
    transition: opacity 0.3s ease, transform 0.3s ease;
    opacity: 0;
    display: none;
    overflow: visible;
    z-index: 1000;
    font-size: .9em;
}
.submenu-popup.submenu-open {
    opacity: 1;
    display: block;
}
.toggle-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 16px;
}
.toggle-btn:hover {
    color: #a3ea18;
}
.icon-centered {
    padding-right: 20px;
}

.bottom-options {
    position: absolute;
    left: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    padding-bottom: .3em;
}

.click-icon {
    color: #FFFFFF;
    cursor: pointer;
}

.click-icon:hover {
    color: #a3ea18;
}

.no-caret {
    appearance: none; /* Hides default caret */
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: none !important; /* Ensures Bootstrap styles don't add a custom caret */
    padding-right: 1rem; /* Adjust padding if necessary */
}

.half-circle-btn {
    position: fixed;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 2em;
    height: 4em;
    background: rgba(0, 0, 0, 0.5); /* semi-transparent black */
    border: none;
    border-top-right-radius: 3em;
    border-bottom-right-radius: 3em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white; /* Icon color */
    cursor: pointer;
    padding: 0;
    padding-right: .3em;
    z-index: 500; /* so it stays on top */
}

.sidebar-tools-section {
    display: none;
}

.tools-divider {
    width: 55%;
    height: 1px;
    background: #6c757d;
    margin: 0.5em auto;
}

.sidebar:not(.collapsed) .tools-divider {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
}

.menu-group-header {
    padding: .6em .7em .2em;
}

.menu-group-divider {
    width: 55%;
    height: 1px;
    background: #6c757d;
    margin: 0 auto .4em;
}

.sidebar:not(.collapsed) .menu-group-divider {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
}

.menu-group-label {
    font-size: .7em;
    text-transform: uppercase;
    letter-spacing: .08em;
    color: #BCBCBC;
    padding-left: .3em;
}

@media (max-width: 768px) {
    .sidebar-tools-section {
        display: block;
    }
}

</style>
